<template>
  <div class="modal fade" id="search-or-add-client-modal" tabindex="-1" aria-labelledby="search-or-add-client-modal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('client')}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
        </div>

        <div class="modal-body">
          <add-client v-if="createClientState" :state="createClientState"  @createClient="createClient"/>
          <auto-complete  
            @emitAutoCompleteClient="emitAutoCompleteClient" 
            :defaultValue="name"
            entity="clients"
            emitEvent="emitAutoCompleteClient"></auto-complete>
            <div class="related-create-link" style="padding: 5px;font-weight: bold;font-size: 12px;" @click="openCreateClientModal">{{$t('create_new_client')}}</div>
          </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('cancel')}}</button>
        </div>
        
    </div>
    </div>
  </div>
</template>

<script>
import AutoComplete from '../components/autocomplete/AutoComplete.vue'
import AddClient from '../components/AddClient.vue';
export default {
  name: 'SearchOrAddClient',
  components : {
    AutoComplete,
    AddClient
  },
  props: {
    state: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      createModal: null,
      createClientState : false,
      name : ''
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('search-or-add-client-modal'))
    if (this.state === true) {
      this.createModal.show()
    }

    document.getElementById('search-or-add-client-modal').addEventListener('hidden.bs.modal', () => {
      this.$emit('saveClient', { state: false })
    })
  },
  methods: {
    saveClient() {
      this.createModal.hide();
    },
    emitAutoCompleteClient(data){
      this.$emit('saveClient', { client: data.result });
      this.createModal.hide();
    },
    openCreateClientModal(){
        this.createClientState = !this.createClientState
    },
    createClient(data){
        if(data.client){
          this.$emit('saveClient', { client: data.client });
          this.createModal.hide();
        }
        if(data && data.state != undefined){
            this.createClientState = data.state
        }
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}
.modal {
  background: white;
  border-radius: 5px;
  max-width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.modal-header, .modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}
.modal-header {
  border-bottom: none;
}
.modal-body {
  padding: 1rem;
}
</style>
